import { snakeCase } from 'change-case'
import * as queryString from 'query-string'

const PAGINATION_QS_BLACKLIST = new Set(['total', 'maxPages', 'counts'])

export interface MetaParams {
  [propName: string]: any
}

export const pushUrl = (params: any, arrayFormat: 'bracket' | 'comma' = 'bracket') =>
  `${window.location.pathname}?${queryString.stringify(params, { arrayFormat })}`

/**
 * returns an object void of null/undefined values
 *
 */
export function cleanParams(meta: MetaParams): MetaParams {
  return Object.keys(meta).reduce((acc, cv) => {
    const key = cv
    const value = meta[cv]

    // remove black list keys
    if (PAGINATION_QS_BLACKLIST.has(key) || value === undefined || value === null || value === '') return acc

    return { ...acc, [key]: value }
  }, {})
}

/**
 * Serializes an object as a query string to the location history via PUSH
 */
export function pushQueryParams(meta: MetaParams, title = ''): void {
  const cleanedParams = cleanParams(meta)
  window.history.pushState(title, title, pushUrl(cleanedParams))
}

/**
 * Serializes an object as query string to the location history via REPLACE
 */
export function replaceQueryParams(meta: MetaParams, title = '') {
  const cleanedParams = cleanParams(meta)
  window.history.replaceState(title, title, pushUrl(cleanedParams))
}

/**
 * Reads QS from window location and returns an object
 */
export function readQueryParams(): MetaParams {
  return queryString.parse(window.location.search, { arrayFormat: 'bracket' })
}

export function snakeParams(meta: MetaParams): MetaParams {
  return Object.keys(meta).reduce((acc, cv) => {
    const key = snakeCase(cv)
    const value = meta[cv]

    return { ...acc, [key]: value }
  }, {})
}

export function stringifyParams(meta: MetaParams, options: any = {}): string {
  return queryString.stringify(snakeParams(cleanParams(meta)), options)
}
